import { render, staticRenderFns, recyclableRender, components } from "./trees.vue?vue&type=template&id=7b997f80&filter-modules=eyJoYW5kbGVyIjp7InR5cGUiOiJzY3JpcHQiLCJjb250ZW50IjoiIiwic3RhcnQiOjU0MjQsImF0dHJzIjp7Im1vZHVsZSI6ImhhbmRsZXIiLCJsYW5nIjoid3hzIiwic3JjIjoiLi9oYW5kbGVyLnd4cyJ9LCJlbmQiOjU0MjR9fQ%3D%3D&"
var renderjs
import script from "./trees.vue?vue&type=script&lang=js&"
export * from "./trees.vue?vue&type=script&lang=js&"
import style0 from "./trees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./handler.wxs?vue&type=custom&index=0&blockType=script&issuerPath=%2FUsers%2Fmac%2FDesktop%2FUceEduFront%2Fnode_modules%2Fuview-ui%2Fcomponents%2Fu-parse%2Flibs%2Ftrees.vue&module=handler&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "node_modules/uview-ui/components/u-parse/libs/trees.vue"
export default component.exports